import { types } from "../types/types";

const initialState = {
  loading: false,
  assignments: []
};

export const flowRoleCiiuAssignmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FLOW_ROLE_CIIU_ASSIGNMENT_START_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    case types.FLOW_ROLE_CIIU_ASSIGNMENT_SET:
      return {
        ...state,
        assignments: action.payload
      };

    case types.AUTH_LOGOUT:
      return initialState;

    default:
      return state;
  }
};
